<table matTableFilter [exampleEntity]="filterEntity"  [filterType]="filterType" mat-table [dataSource]="dataSource" aria-describedby="tableWithAction">
    <ng-container  *ngFor="let col of columnsSchema">
        <ng-container [matColumnDef]="col.key" *ngIf="col.key==='filter_'">
            <th mat-header-cell *matHeaderCellDef>
                <button mat-flat-button class="Icon-Btn"
                    name="btnPostCnb" (click)="toggleFilter()">
                    <img src="assets/images/icons/default_icons/filter.new.png" alt="icon-next">
                </button>
            </th>
            <td mat-cell *matCellDef="let elem">

            </td>
        </ng-container>
        <ng-container [matColumnDef]="col.key" *ngIf="col.key==='download_'">
            <th mat-header-cell  *matHeaderCellDef>
                <button mat-raised-button class="Icon-Btn filter_class" id="downloadSuccessDataCnbNew"
                    (click)="downloadTableData()">
                    <span> <img alt="download new" src="assets/images/icons/purple_icons/icon-download.png"></span>
                </button>
            </th>
            <td mat-cell *matCellDef="let elem">

            </td>
        </ng-container>
        <ng-container [matColumnDef]="col.key" *ngIf="col.key!='download_' && col.key!='filter_'">
            <th mat-header-cell [ngStyle]="{'min-width': (col.type === 'date' || col.type === 'time') ? '142px' : 'unset'}" *matHeaderCellDef [class.centerHeader]="selectedTab() === 'HR Offer DB' || selectedTab() === 'Action Pending' || selectedTab() === 'Overall Status'"> {{col.label}}
                <div [ngStyle]="{'visibility': filterTble(col.key) ? 'visible' : 'hidden' , 'height': filterTble(col.key) ? 'auto' : '0'}" [ngSwitch]="col.filterType || col.type">
                    <ng-container *ngSwitchCase="'date'">
                        @if (dateRangeFilters[col.key]) {
                            <div class="filterInputWrapper">
                                <mat-date-range-input [rangePicker]="rangePicker" class="dateRangeFilter">
                                    <input matStartDate placeholder="From" [(ngModel)]="dateRangeFilters[col.key].start" (dateChange)="applyAllFilters()">
                                    <input matEndDate placeholder="To" [(ngModel)]="dateRangeFilters[col.key].end" (dateChange)="applyAllFilters()">
                                </mat-date-range-input>
                                @if (dateRangeFilters[col.key].start || dateRangeFilters[col.key].end) {
                                    <button mat-icon-button type="button" class="clearFilterBtn" (click)="clearDateFilter(col.key)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                                <mat-datepicker-toggle [for]="rangePicker" class="datePickerToggle"></mat-datepicker-toggle>
                                <mat-date-range-picker #rangePicker></mat-date-range-picker>
                            </div>
                        }
                    </ng-container>
                    <ng-container *ngSwitchCase="'select'">
                        <mat-select [(ngModel)]="selectFilters[col.key]" (selectionChange)="applyAllFilters()" placeholder="All" class="inputFilter">
                            <mat-option value="">All</mat-option>
                            <mat-option *ngFor="let opt of getDistinctColumnValues(col.key)" [value]="opt">
                                {{col.valueMap ? (col.valueMap[opt] ?? opt) : opt}}
                            </mat-option>
                        </mat-select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'time'">
                        @if (timeRangeFilters[col.key]) {
                            <div class="filterInputWrapper">
                                <input class="inputFilter" style="width:75px" placeholder="From"
                                    [ngxTimepicker]="startTp" [(ngModel)]="timeRangeFilters[col.key].start"
                                    (ngModelChange)="applyAllFilters()" readonly>
                                <ngx-material-timepicker #startTp></ngx-material-timepicker>
                                <input class="inputFilter" style="width:75px" placeholder="To"
                                    [ngxTimepicker]="endTp" [(ngModel)]="timeRangeFilters[col.key].end"
                                    (ngModelChange)="applyAllFilters()" readonly>
                                <ngx-material-timepicker #endTp></ngx-material-timepicker>
                                @if (timeRangeFilters[col.key].start || timeRangeFilters[col.key].end) {
                                    <button mat-icon-button type="button" class="clearFilterBtn" (click)="clearTimeFilter(col.key)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                            </div>
                        }
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input class="inputFilter" [placeholder]="col.label" [(ngModel)]="filterEntity[col.key]">
                    </ng-container>
                 </div>
            </th>
            <ng-container *ngIf="col.key!='action' && col.key!='editAction'">
                <td mat-cell *matCellDef="let elem">
                    <ng-container *ngIf="col.editableColumn && isRowEditing(elem); else clickableOrPlain">
                        <ng-container *ngIf="col.type === 'select'; else textEdit">
                            <mat-select [(ngModel)]="editingRowData[col.key]" style="min-width:150px;" placeholder="--Select an option--">
                                <mat-option *ngFor="let opt of (selectOptions[col.key] || col.options || [])" [value]="opt.value">
                                    {{opt.label}}
                                </mat-option>
                            </mat-select>
                        </ng-container>
                        <ng-template #textEdit>
                            <input class="inputFilter" [(ngModel)]="editingRowData[col.key]" style="min-width:150px;">
                        </ng-template>
                    </ng-container>
                    <ng-template #clickableOrPlain>

                        @if (col.isClickable && col.clickableChip) {
                        @if (elem[col.key]) {
                        <mat-chip-set>
                            <mat-chip (click)="onCellClick(col, elem)" style="cursor: pointer;">
                                <span class="chip-truncate" [matTooltip]="elem[col.key]" matTooltipShowDelay="300">
                                    {{ elem[col.key] }}
                                </span>
                            </mat-chip>
                        </mat-chip-set>
                        }
                        }
                        @else if (col.isClickable) {
                        <a href="javascript:void(0)" style="text-decoration: none;" (click)="onCellClick(col, elem)">
                            {{ elem[col.key] }}
                        </a>
                        } 
                        @else if(col.pipe === 'dateTime') {
                            @if(!elem[col.key] || elem[col.key] === 'NA') {
                                NA
                            } @else {
                            <span>{{elem[col.key] | date:'dd/MM/yyyy'}}</span><br><span>{{elem[col.key] | date:'hh:mm a'}}</span>
                        }
                        }
                         @else if (col.pipe === 'time') {
                        {{elem[col.key] | date:'hh:mm a'}}
                        }
                        @else if(col.pipe === 'date' || col.key === 'requestedOn') {
                            @if(!elem[col.key] || elem[col.key] === 'NA') {
                                NA
                            } @else {
                                {{elem[col.key] | date:'mediumDate'}}
                            }
                        }
                        @else if(col.valueMap) {
                            {{col.valueMap[elem[col.key]] ?? elem[col.key]}}
                        }
                        @else if (col.type === 'chips') {
                            <span class="skills-truncate" [matTooltip]="col.tooltipFormatter ? col.tooltipFormatter(elem) : elem[col.key]"
                                 matTooltipShowDelay="300">
                                {{ col.tooltipFormatter ? col.tooltipFormatter(elem) : elem[col.key] }}
                            </span>
                        }
                        @else {
                            {{elem[col.key]}}
                            }
                    </ng-template>
                </td>
            </ng-container>
            <ng-container *ngIf="col.key=='action'">
                <td mat-cell *matCellDef="let elem" style="text-align: center;">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                        <button class="primary-btn" (click)="approveReq(elem)">Approve</button>
                        <button class="secondary-btn" (click)="rejectReq(elem)">Reject</button>
                    </div>
                </td>
            </ng-container>
            <ng-container *ngIf="col.key=='editAction'">
                <td mat-cell *matCellDef="let elem" style="text-align: center;">
                    <ng-container *ngIf="!isRowEditing(elem)">
                        <button mat-icon-button (click)="startEdit(elem)" matTooltip="Edit">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </ng-container>
                    <ng-container *ngIf="isRowEditing(elem)">
                        <button mat-icon-button (click)="saveEdit()" matTooltip="Save" style="color:#4CAF50;">
                            <mat-icon>check</mat-icon>
                        </button>
                        <button mat-icon-button (click)="cancelEdit()" matTooltip="Cancel" style="color:#f44336;">
                            <mat-icon>close</mat-icon>
                        </button>
                    </ng-container>
                </td>
            </ng-container>
        </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #paginatorSalGrid [length]="10" [pageSize]="25" [pageSizeOptions]="[10, 25, 50]"
    [showFirstLastButtons]="true">
</mat-paginator>